<template>
  <div>
    <h1>Рідне Слово</h1>

    <p>Увійдіть або зареєструйтеся на цьому веб-сайті за допомогою кнопки входу нижче.</p>

    <button @click="authenticate()" class="btn btn-outline-dark"><icon name="sign-in"></icon>Увійти</button>
  </div>
</template>

<script>

import auth from '../services/auth'

import 'vue-awesome/icons/sign-in'

export default {
  name: 'login',
  methods: {
    authenticate (provider) {
      return auth.authenticate(provider)
    }
  }
}
</script>



// WEBPACK FOOTER //
// Login.vue?5f7b7e36